import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import axios from 'axios'
import requestService from "@/store/backendRequests"
import DateFnsAdapter from '@date-io/date-fns'
import { de as datede } from 'date-fns/locale/de'
import de from 'vuetify/lib/locale/de'
import en from 'vuetify/lib/locale/en'
import {VTimePicker} from "vuetify/components";

//axios config
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:4000'

axios.interceptors.request.use(
    (config) => {
        const token = getAccessToken();
        if (token) {
            config.headers["Authorization"] = token;
        }
        // Do something before request is sent
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response;
    },
    async (error) => {
        const originalConfig = error.config;
        if (error.response) {
            // Access Token was expired
            if (error.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                try {
                    const response = await requestService.refreshToken(getRefreshToken());
                    const accessToken = response.data.tokenType + " " +response.data.accessToken;
                    window.sessionStorage.setItem("accessToken", accessToken);
                    axios.defaults.headers.common["Authorization"] = accessToken;

                    return axios(originalConfig);
                } catch (_error) {
                    return Promise.reject(_error);
                }
            }

        }
        return Promise.reject(error);
    }
);

function getAccessToken() {
    const accessToken = window.sessionStorage.getItem("accessToken");
    return accessToken;
}

function getRefreshToken() {
    const refreshToken = window.sessionStorage.getItem("refreshToken");
    return refreshToken;
}

//vuetify config
const vuetify = createVuetify({
    components: {
        ...components,
        VTimePicker
    },
    locale: {
        locale: 'de',
        fallback: 'en',
        messages: { de, en },
    },
    directives,
    date: {
        adapter: DateFnsAdapter,
        locale: {
            de: datede
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        }
    },
})
createApp(App).use(store).use(router).use(vuetify).mount('#app')
